import React, { useMemo } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";


const logo = `${process.env.PUBLIC_URL || ""}/logo_novo.png`;

const COMPANY_NAME = "MCP REFEICOES LTDA ME";
const COMPANY_CNPJ = "06.088.039/0001-99";
const opcoes = { day: '2-digit', month: '2-digit', year: 'numeric' };


const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    padding: 48,
    position: "relative",
    fontFamily: "Helvetica",
  },
  border: {
    position: "absolute",
    top: 28,
    left: 28,
    right: 28,
    bottom: 28,
    border: "3pt solid #D71920",
    borderRadius: 8,
  },
  innerBorder: {
    position: "absolute",
    top: 40,
    left: 40,
    right: 40,
    bottom: 40,
    border: "1pt solid #E5E5E5",
    borderRadius: 6,
  },
  logo: {
    position: "absolute",
    top: 52,
    left: 58,
    width: 95,
    height: 95,
    objectFit: "contain",
  },
  watermark: {
    position: "absolute",
    top: 160,
    left: 205,
    width: 430,
    height: 430,
    opacity: 0.05,
    objectFit: "contain",
  },
  label: {
    position: "absolute",
    top: 58,
    right: 58,
    fontSize: 8,
    color: "#666666",
    textTransform: "uppercase",
  },
  titleWrap: {
    marginTop: 98,
    alignItems: "center",
  },
  title: {
    fontSize: 34,
    fontFamily: "Times-Bold",
    color: "#171717",
    letterSpacing: 1,
  },
  subtitle: {
    marginTop: 8,
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    color: "#D71920",
    letterSpacing: 1.5,
    textTransform: "uppercase",
  },
  line: {
    marginTop: 14,
    width: 90,
    height: 2,
    backgroundColor: "#D71920",
  },
  content: {
    marginTop: 48,
    alignItems: "center",
  },
  intro: {
    fontSize: 12,
    color: "#666666",
  },
  studentName: {
    marginTop: 18,
    fontSize: 28,
    fontFamily: "Times-Bold",
    color: "#D71920",
    textAlign: "center",
  },
  text: {
    marginTop: 28,
    fontSize: 12,
    color: "#171717",
  },
  courseName: {
    marginTop: 16,
    maxWidth: 620,
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    color: "#171717",
    textAlign: "center",
  },
  completionLabel: {
    marginTop: 30,
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: "#666666",
    textTransform: "uppercase",
  },
  completionDate: {
    marginTop: 6,
    fontSize: 11,
    color: "#171717",
  },
  companyBox: {
    position: "absolute",
    left: 58,
    right: 58,
    bottom: 95,
    minHeight: 58,
    padding: 12,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F7F7F5",
    borderRadius: 6,
  },
  companyLabel: {
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: "#666666",
    textTransform: "uppercase",
  },
  companyName: {
    marginTop: 6,
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    color: "#171717",
  },
  companyDocument: {
    marginTop: 3,
    fontSize: 8,
    color: "#666666",
  },
  validationCode: {
    position: "absolute",
    right: 58,
    bottom: 58,
    fontSize: 7,
    color: "#666666",
  },
});

export function CertificateButton({
  studentName,
  courseName,
  className = "mt-4",
}) {
  return (
    <PDFDownloadLink
      document={
        <Certificate
          studentName={studentName || "Aluno"}
          courseName={courseName || "Curso"}
        />
      }
      fileName="certificado.pdf"
      className={`${className} block w-full rounded-md bg-white py-2 text-center font-semibold text-[#B95758] shadow-sm transition hover:bg-gray-100`}
    >
      {({ loading }) =>
        loading ? "Gerando certificado..." : "Baixar certificado"
      }
    </PDFDownloadLink>
  );
}

export function Certificate({
  studentName,
  courseName,
}) {
  const validationCode = useMemo(() => crypto.randomUUID(), []);
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.border} />
        <View style={styles.innerBorder} />

        <Image src={logo} style={styles.logo} />
        <Image src={logo} style={styles.watermark} />

        <Text style={styles.label}>Certificado</Text>

        <View style={styles.titleWrap}>
          <Text style={styles.title}>CERTIFICADO</Text>
          <Text style={styles.subtitle}>De conclusao de curso</Text>
          <View style={styles.line} />
        </View>

        <View style={styles.content}>
          <Text style={styles.intro}>Certificamos que</Text>
          <Text style={styles.studentName}>{studentName}</Text>
          <Text style={styles.text}>concluiu o curso</Text>
          <Text style={styles.courseName}>{courseName}</Text>
          <Text style={styles.completionLabel}>Data de conclusao</Text>
          <Text style={styles.completionDate}>{new Date().toLocaleDateString('pt-BR', opcoes)}</Text>
        </View>

        <View style={styles.companyBox}>
          <Text style={styles.companyLabel}>Empresa emissora</Text>
          <Text style={styles.companyName}>{COMPANY_NAME}</Text>
          <Text style={styles.companyDocument}>CNPJ: {COMPANY_CNPJ}</Text>
        </View>

        <Text style={styles.validationCode}>
          Codigo de validacao: {validationCode}
        </Text>
      </Page>
    </Document>
  );
}






